// ACTIONS
const HTTP_REQUEST = 'HTTP_REQUEST';
const HTTP_SUCCESS = 'HTTP_SUCCESS';
const HTTP_FAILURE = 'HTTP_FAILURE';
const HTTP_CLEAR = 'HTTP_CLEAR';

const defaultState = {
    isLoading: null,
    erreur: null,
    message: null,
    data: null,
    codeStatut: null,
};

// Reducer pour RNA qui gère la structure directe de la réponse
const rnaReducer =
    (context) =>
    (state = defaultState, action = {}) => {
        switch (action.type) {
            case context + HTTP_REQUEST:
                return {
                    ...defaultState,
                    isLoading: true,
                };
            case context + HTTP_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    erreur: false,
                    data: action.payload.data,
                    message: action.payload.data.message,
                    codeStatut: action.payload.status,
                };
            case context + HTTP_FAILURE:
                if (action.payload) {
                    return {
                        ...state,
                        isLoading: false,
                        erreur: true,
                        data: action.payload.data,
                        message: action.payload.data?.message,
                        codeStatut: action.payload.status,
                    };
                }

                return {
                    ...state,
                    isLoading: false,
                    erreur: true,
                    data: null,
                    message: null,
                    codeStatut: 503,
                };

            case context + HTTP_CLEAR:
                return defaultState;
            default:
                return state;
        }
    };

export default rnaReducer;
